// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsSource;
(function (HhsSource) {
    HhsSource["Interest"] = "interest";
    HhsSource["Prescriber"] = "prescriber";
})(HhsSource || (HhsSource = {}));
//# sourceMappingURL=hhsSource.js.map